<template>
  <div>
    <v-container fluid>
      <PageWrapper>
        <template #title>Табло вылета</template>
        <template #actions>
          <v-btn
            color="red"
            icon
            class="my-0 white--text"
            v-show="departureDate"
            :disabled="!!!departureDate"
            @click="departureDate = ''"
          >
            <v-icon>close</v-icon>
          </v-btn>
          <v-menu
            lazy
            :close-on-content-click="false"
            v-model="datePicker"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            z-index="100"
          >
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" outline class="departure-date my-0" style="border-radius: 5px">
                {{departureDate ? moment(departureDate).format('DD.MM.YYYY') : 'Дата' }}
                <v-icon class="ml-3">calendar_month</v-icon>
              </v-btn>
            </template>
            <v-date-picker
              v-model="departureDate"
              @input="datePicker = false"
              locale="ru-RU"
              no-title
              scrollable
            >
            </v-date-picker>
          </v-menu>
          <v-btn color="primary" @click="update" class="my-0">Обновить</v-btn>
        </template>

        <v-divider></v-divider>
        <TableWrapper auto-scroll height="82vh" v-if="!preloader">
          <v-data-table
            :headers="this.headers"
            :items="this.departureBoard"
            :search="search"
            class="elevation-0 small-table"
            hide-actions
          >
            <template #headers='props'>
              <th
                class='column text-xs-left'
                v-for='h in props.headers'
                :key='h.value'
                @click='h.fn && h.fn()'
                v-show='!h.isHide'
                :class="{'cursor-pointer': !!h.fn}"
              >
                {{h.text}}
              </th>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <span class="body-2">{{ props.item.FlightNumber }}</span>
              </td>
              <td class="text-xs-left">
                <template v-if="props.item.DelayTime !== null && props.item.Status === 'ЗАДЕРЖАН' ">
                  <span class="crossed-text">{{ props.item.DepTime }}</span>
                  <span
                    class='red--text ml-2'
                  >{{ props.item.DelayTime }}</span>
                </template>
                <template v-else-if="props.item.id_status === '13'">
                  <span
                  >{{ props.item.DepTime }}</span>
                </template>
                <template v-else>
                  <span
                  >{{ props.item.DepTime }}</span>
                </template>
              </td>
              <td class="text-xs-left">{{ props.item.DepDate }}</td>
              <td class="text-xs-left">{{ isCodeAirportSelect ? props.item.CodeAirport : props.item.ap_name }}</td>
              <td class="text-xs-left">{{ props.item.CheckIn }}</td>
              <td class="text-xs-left">{{ props.item.Exit }}</td>
              <td class="text-xs-left">
                <v-chip
                  :color="props.item.StatusColor || 'blue-grey lighten-3'"
                  small
                  text-color="white"
                >{{ (props.item.Status || 'по расписанию').toLowerCase() }}</v-chip>
              </td>
              <td class="text-xs-left">
                <div v-if="props.item.logo" v-html="imgWrap(props.item.logo, logoSize)"></div>
              </td>
              <td class="text-xs-left">
                {{ props.item.DelayCode ? props.item.DelayCode + ': ' + props.item.DelayCodeTitle : ''}}
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Поиск по "{{ search }}" не дал результатов.</v-alert>
          </v-data-table>

        </TableWrapper>
        <div class="preload-box pa-2" style="height: 84.5vh" v-else>
          <v-progress-circular indeterminate :size="loaderSize" color="primary"></v-progress-circular>
        </div>
      </PageWrapper>
    </v-container>
  </div>
</template>

<script>
import store from '@/store'
import PageWrapper from "../ui/PageWrapper.vue";
import moment from "moment";
import TableWrapper from "../ui/TableWrapper.vue";

export default {
  components: {TableWrapper, PageWrapper},
  data() {
    return {
      search: '',
      datePicker: false,
      logoSize: 30,
      perPage: [15, 30, 50, { text: 'Все', value: -1 }],
      isCodeAirportSelect: true,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: '№ Рейса',
          align: 'left',
          sortable: false,
          value: 'FlightNumber',
        },
        {
          text: 'Отправление',
          sortable: false,
          value: 'DepTime',
        },
        {
          text: 'Дата',
          sortable: false,
          value: 'DepDate',
        },
        {
          text: 'Направление',
          sortable: false,
          value: 'CodeAirport',
          isHide: !this.isCodeAirportSelect,
          fn: () => this.isCodeAirportSelect = false
        },
        {
          text: 'Направление',
          sortable: false,
          value: 'ap_name',
          isHide: this.isCodeAirportSelect,
          fn: () => this.isCodeAirportSelect = true
        },
        {
          text: 'Стойки',
          sortable: false,
          value: 'CheckIn',
        },
        {
          text: 'Посадка',
          sortable: false,
          value: 'Exit',
        },
        {
          text: 'Статус',
          sortable: false,
          value: 'Status',
        },
        {
          text: 'Авиакомпания',
          sortable: false,
          value: 'logo',
        },
        {
          text: 'Причина задержки',
          sortable: false,
          value: 'DelayCode',
        },
      ]
    },
    departureBoard: {
      get() {
        return store.getters['board/getDepartureBoard'](this.departureDate || 'current')
      },
      set(value) {
        store.commit('board/setDepartureBoard', value)
      },
    },
    preloader: {
      get() {
        return store.getters['board/getDeparturePreloader']
      },
      set(value) {
        store.commit('board/setDeparturePreloaderState', value)
      },
    },
    departureDate: {
      get() {
        return store.getters['board/getDepartureDate']
      },
      set(value) {
        store.commit('board/setDepartureDate', value)
      },
    },
  },
  methods: {
    moment,
    update: function() {
      store.dispatch('board/updateDepartureBoard')
    },
    imgWrap: function(url, size) {
      return '<img height="' + size + 'px" src="' + url + '"/>'
    },
  },
  mounted: function() {
    store.commit('setPageTitle', 'Табло вылета')
  },
}
</script>
<style scoped>
.crossed-text {
  text-decoration: line-through ;
}
.cursor-pointer {
  cursor: pointer;
}
.departure-date {
  border: 1px solid #8AA1AC;
  border-radius: 5px;
  color: #232323;
  text-transform: none;
  width: 143px;
  i {
    margin-left: auto;
    color: #8AA1AC !important;
  }
  .v-btn__content {
    width: 143px;
    display: flex;

    align-items: center;

    justify-content: space-between;
    padding: 0 8px;

  }
}
</style>
